import React from 'react';
import useLectureTts from '../../hooks/useLectureTts';
import { SBA } from '../../theme';

export default function LectureTtsControls({
  text,
  resetKey,
  enabled = true,
  accentColor = SBA.navy,
}) {
  const { supported, status, error, play, pause, stop, canPlay } = useLectureTts({
    text,
    resetKey,
    enabled,
  });

  if (!supported) {
    return (
      <span style={styles.unavailable} title="Text-to-speech is not available in this browser">
        <span className="material-symbols-outlined" style={{ fontSize: 15 }}>volume_off</span>
        TTS unavailable
      </span>
    );
  }

  const busy = status === 'speaking' || status === 'paused';

  return (
    <div style={styles.wrap}>
      {status !== 'speaking' ? (
        <button
          type="button"
          onClick={play}
          disabled={!canPlay || !enabled}
          style={{
            ...styles.btn,
            borderColor: `${accentColor}40`,
            color: accentColor,
            opacity: !canPlay || !enabled ? 0.45 : 1,
          }}
          title={status === 'paused' ? 'Resume reading' : 'Listen to lecture'}
        >
          <span className="material-symbols-outlined" style={{ fontSize: 16 }}>
            {status === 'paused' ? 'play_arrow' : 'volume_up'}
          </span>
          {status === 'paused' ? 'Resume' : 'Listen'}
        </button>
      ) : (
        <button
          type="button"
          onClick={pause}
          style={{ ...styles.btn, borderColor: `${accentColor}40`, color: accentColor }}
          title="Pause reading"
        >
          <span className="material-symbols-outlined" style={{ fontSize: 16 }}>pause</span>
          Pause
        </button>
      )}

      {busy && (
        <button
          type="button"
          onClick={stop}
          style={styles.stopBtn}
          title="Stop reading"
        >
          <span className="material-symbols-outlined" style={{ fontSize: 16 }}>stop</span>
          Stop
        </button>
      )}

      {status === 'speaking' && (
        <span style={{ ...styles.live, color: accentColor }}>
          <span className="material-symbols-outlined" style={{ fontSize: 14 }}>graphic_eq</span>
          Reading…
        </span>
      )}

      {error && <span style={styles.error}>{error}</span>}
    </div>
  );
}

const styles = {
  wrap: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: 8,
    flexWrap: 'wrap',
  },
  btn: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: 5,
    background: '#fff',
    border: '1px solid',
    borderRadius: 20,
    padding: '4px 12px',
    fontSize: 12,
    fontWeight: 600,
    cursor: 'pointer',
    fontFamily: 'Plus Jakarta Sans, sans-serif',
  },
  stopBtn: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: 5,
    background: '#fff',
    border: '1px solid #fecaca',
    borderRadius: 20,
    padding: '4px 12px',
    fontSize: 12,
    fontWeight: 600,
    color: '#b91c1c',
    cursor: 'pointer',
    fontFamily: 'Plus Jakarta Sans, sans-serif',
  },
  live: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: 4,
    fontSize: 11,
    fontWeight: 700,
  },
  error: {
    fontSize: 11,
    color: '#b91c1c',
    fontWeight: 500,
  },
  unavailable: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: 5,
    fontSize: 11,
    color: '#94a3b8',
    fontWeight: 600,
  },
};
